import { jsxs as a, jsx as i } from "react/jsx-runtime";
import { c as t } from "./extends-2c39a7b4.js";
import { H as v, B as n } from "./pp-react-text.esm-fc0bee1c.js";
import { a as g, R as u, C as O } from "./getButtonHref-4b514703.js";
import { C as Q } from "./ContentRenderer-b6eef314.js";
import { I as A } from "./Image-ad475371.js";
import { H as d } from "./helpers-7c298f27.js";
import { w as H } from "./propsChecker-7de44c11.js";
const L = "_testimonial_1e2e3_1", b = "_testimonialRow_1e2e3_5", q = "_testimonialRowReverse_1e2e3_8", z = "_testimonialContentCol_1e2e3_11", B = "_testimonialQuoteIcon_1e2e3_14", P = "_imageparent_1e2e3_20", j = "_testimonialSubheadingText_1e2e3_23", M = "_testimonialQuoteText_1e2e3_28", V = "_testimonialAuthorOrgText_1e2e3_35", Z = "_testimonialImage_1e2e3_48", e = {
  testimonial: L,
  testimonialRow: b,
  testimonialRowReverse: q,
  testimonialContentCol: z,
  testimonialQuoteIcon: B,
  imageparent: P,
  testimonialSubheadingText: j,
  testimonialQuoteText: M,
  testimonialAuthorOrgText: V,
  testimonialImage: Z
}, k = "TestimonialTemplate", _ = ({
  className: T,
  testimonialStyles: o = {},
  layout: s = {},
  subheading: m,
  quote: x,
  name: l,
  role: r,
  organization: p,
  imageUrl: c,
  imageAltText: w,
  imagePosition: R = d.Right,
  analyticsCompName: I = "Testimonial",
  ...N
}) => {
  const C = /* @__PURE__ */ a(
    g,
    {
      className: t(
        e.testimonialContentCol,
        o.contentCol
      ),
      ...s.contentColLayout,
      children: [
        /* @__PURE__ */ i(
          "svg",
          {
            className: t(
              e.testimonialQuoteIcon,
              o.quotesIcon
            ),
            width: "30",
            height: "31",
            viewBox: "0 0 30 31",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ i(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.3351 12.1368C11.0427 12.1987 11.6985 12.4145 12.2958 12.7443L12.2959 12.7442C11.0623 15.1072 10.2261 17.7687 10.2238 20.5125C10.2238 22.7341 10.7671 24.9856 11.7871 26.9316C10.7476 27.4469 9.58405 27.7319 8.36882 27.7319C3.20244 27.7319 0 22.7375 0 17.7444C0 12.8277 3.20215 7.83471 6.62278 4.83985C9.89756 1.92026 12.3716 0.76839 13.9727 0.538015C15.6463 0.307636 16.4468 1.15276 16.4468 2.30463C16.4468 3.54389 14.9265 4.50611 13.8438 5.1914C13.6509 5.31346 13.4719 5.42674 13.3179 5.53123C10.0433 7.6044 8.0057 9.52512 8.0057 10.985C8.0057 11.9427 9.27547 12.0476 10.0678 12.113C10.1652 12.121 10.2554 12.1285 10.3351 12.1368ZM22.9739 14.8812C23.0713 14.8892 23.1615 14.8967 23.2412 14.905L23.2409 14.9049C26.7351 15.2116 28.991 19.2068 28.991 22.6637C28.991 27.1971 25.4245 30.5 21.277 30.5C16.1106 30.5 12.9082 25.5057 12.9082 20.5126C12.9082 15.5959 16.1094 10.6029 19.5301 7.60804C22.8048 4.68845 25.2788 3.53658 26.88 3.3062C28.5535 3.07582 29.3541 3.92095 29.3541 5.07281C29.3541 6.31177 27.8337 7.27382 26.7508 7.95908C26.5576 8.08134 26.3783 8.19478 26.224 8.29942C22.9494 10.3726 20.9118 12.2933 20.9118 13.7532C20.9118 14.7109 22.1816 14.8157 22.9739 14.8812Z",
                fill: "white"
              }
            )
          }
        ),
        m && /* @__PURE__ */ i(
          v,
          {
            as: "h3",
            size: "md",
            className: t(
              e.testimonialSubheadingText,
              o.subheadingText
            ),
            children: m
          }
        ),
        /* @__PURE__ */ i(
          Q,
          {
            className: t(
              e.testimonialQuoteText,
              o.quoteText
            ),
            analyticsCompName: I,
            as: "p",
            content: x
          }
        ),
        l && /* @__PURE__ */ i(
          n,
          {
            as: "p",
            className: t(
              e.testimonialAuthorOrgText,
              o.authorOrgText
            ),
            children: l
          }
        ),
        r && /* @__PURE__ */ i(
          n,
          {
            as: "p",
            className: t(
              e.testimonialAuthorOrgText,
              o.authorOrgText
            ),
            children: r
          }
        ),
        /* @__PURE__ */ i(
          n,
          {
            as: "p",
            className: t(
              e.testimonialAuthorOrgText,
              o.authorOrgText
            ),
            children: p
          }
        )
      ]
    }
  ), h = /* @__PURE__ */ i(
    g,
    {
      className: t(e.imageparent, o.imageCol),
      ...s.imageColLayout,
      children: c && /* @__PURE__ */ i(
        A,
        {
          className: t(e.testimonialImage, o.image),
          src: c,
          alt: w,
          lazyLoad: !0,
          dimensions: {
            minHeight: "12.5rem",
            minWidth: "12.5rem"
          }
        }
      )
    }
  ), f = R === d.Right ? /* @__PURE__ */ a(u, { className: t(e.testimonialRow, o.row), children: [
    C,
    h
  ] }) : /* @__PURE__ */ a(
    u,
    {
      className: t(
        e.testimonialRow,
        e.testimonialRowReverse,
        o.row
      ),
      children: [
        h,
        C
      ]
    }
  );
  return /* @__PURE__ */ i(O, { className: t(e.testimonial, T), ...N, children: f });
};
_.requiredProps = {
  layout: !0,
  quote: !0,
  organization: !0
};
const Y = H(
  _,
  k
);
export {
  Y as V
};
//# sourceMappingURL=TestimonialTemplate-509a570d.js.map
